// extracted by mini-css-extract-plugin
module.exports = {"container":"DateStyles_container__1tubc"};